import info from './landing/themes/info/settings.json'
import med from './landing/themes/med/settings.json'
import drept from './landing/themes/drept/settings.json'
import rezi from './landing/themes/rezi/settings.json'

const byType = { info, med, drept, rezi }
const appType = process.env.REACT_APP_TYPE
export const settings =
  appType && appType in byType ? byType[appType as keyof typeof byType] : info
